import { createSlice } from "@reduxjs/toolkit";

const screenshotSlice = createSlice({
  name: "screenshotSetup",
  initialState: {
    screenshotData: null,
  },
  reducers: {
    setScreenshotData: (state, action) => {
      state.screenshotData = action?.payload
    },
    clearScreenshotData: (state, action) => {
      state.screenshotData = null
    },
  }
});


// this is for dispatch
export const { screenshotData, clearScreenshotData } = screenshotSlice.actions;

// this is for configureStore
export default screenshotSlice.reducer;